// extracted by mini-css-extract-plugin
module.exports = {"Logo":"ModalystLogo_Logo__1kJkz","Reversed":"ModalystLogo_Reversed__2Icj0"};